import { connect } from 'react-redux';
import TableauDashboard from './tableau-dashboard';
import {
  instantiateDashboard,
  fetchTableauToken
} from '../../actions/analytics';
import { broadcastWindowActivity } from '../../core/session-activity';

const mapStateToProps = function(
  state: CMx.ApplicationState
): AppProps.DashboardProperties {
  const { analytics, ui } = state;
  return {
    ...analytics,
    serviceLine: ui.serviceLine,
    activeHealthSystemCode: ui.context.activeHealthSystemCode ?? '',
    activeDashboardResource: analytics.activeDashboardResource,
    dashboardPaths: analytics.dashboardPaths
  };
};

const mapDispatchToProps = (dispatch: any): AppProps.DashboardMethods => {
  return {
    instantiateDashboard: (serviceLine?: CMx.ServiceLine) => {
      dispatch(fetchTableauToken(serviceLine));
      dispatch(instantiateDashboard());
    },
    registerActivity: broadcastWindowActivity
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TableauDashboard);
